// https://developers.google.com/youtube/player_parameters
// https://developers.google.com/youtube/iframe_api_reference


let $youtubeWrapper;
$(document).ready(function() {
	let $youtube = $('a.youtube');

	if (!$youtube.length) {
		return;
	}

	let initVideoCode = function ($item, index) {
		let code = $item.attr('href').match(/(youtube.com\/watch\?v=|youtube.com\/embed\/|youtu.be\/)([A-z0-9_-]+)/i)[2];
		$item.parent().attr('index', index).attr('code', code);
	}

	let clickVideo = function () {
		let $this = $(this);
		$youtubeWrapper = $this.parent();

		$this.attr('hidden', true);

		$youtubeWrapper.append('<div class="videoBox"><div><div id="youtubeplayer-' + $youtubeWrapper.attr('code') + '-' + $youtubeWrapper.attr('index') + '"></div></div></div>');

		if (typeof YT === 'object') {
			createYoutubePlayerToWrapper();
		}
		else {
			$('body').append('<script src="https://www.youtube.com/iframe_api" type="text/javascript"></script>');
		}

		return false;
	}

	$youtube.each(function (index) {
		let $this = $(this);
		initVideoCode($this, index);
	}).click(clickVideo);
});


function createYoutubePlayerToWrapper() {
	if ($youtubeWrapper === undefined) {
		return;
	}

	new YT.Player('youtubeplayer-' + $youtubeWrapper.attr('code') + '-' + $youtubeWrapper.attr('index'), {
		videoId: $youtubeWrapper.attr('code'),
		playerVars: {
			hl: $('html').attr('lang'),
			rel: 0
		},
		events: {
			'onReady': function (event) {
				event.target.playVideo();
			}
		}
	});

	$youtubeWrapper = undefined;
}


window.onYouTubeIframeAPIReady = function () {
	createYoutubePlayerToWrapper();
}
